export const configApi = 'https://api.generaideasia.com/api/'  